<template>
  <div>
    <appHeader></appHeader>
    <div class="container-fluid login-orders-report">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <appAdminSidebar></appAdminSidebar>
        </div>
        <transition appear name="fade">
          <div class="col-md-9 p-4">
            <h4>Transaction Report</h4>

            <hr />
            <div class="mt-2">
              <div>
                <label style="font-size: 16px">Transaction Report</label>
              </div>
              <div>
                <strong>Dates: </strong>
                <span>
                  {{
                    moment(this.form.start_date.substring(0, 10)).format(
                      "MM/DD/YYYY"
                    )
                  }}</span
                >
                -
                <span>{{
                  moment(this.form.end_date.substring(0, 10)).format(
                    "MM/DD/YYYY"
                  )
                }}</span>
              </div>

              <div>
                <strong>Clients: </strong>
                <span>
                  {{
                    this.form.is_all_clients_selected ? "All" : "Selected"
                  }}</span
                >
              </div>

              <div>
                <strong>Programs & Contests: </strong>
                <span>
                  {{
                    this.form.is_all_programs_selected ? "All" : "Selected"
                  }}</span
                >
              </div>

              <div>
                <strong>User Codes: </strong>
                <span>
                  {{
                    this.form.is_all_user_code_selected ? "All" : "Selected"
                  }}</span
                >
              </div>

              <div>
                <strong>Transaction Types: </strong>
                <span>
                  {{
                    this.form.is_all_transactions_selected
                      ? "All"
                      : this.form.transaction_types.join(", ")
                  }}</span
                >
              </div>

              <div>
                <strong>Show All Records: </strong>
                <span> {{ this.form.show_total ? "No" : "Yes" }}</span>
              </div>

              <div>
                <strong>Total Points: </strong>
                <span v-if="this.transactionReports.total_points == null"
                  >0</span
                >
                <span v-else>
                  {{
                    this.transactionReports.total_points.toLocaleString()
                  }}</span
                >
              </div>

              <div>
                <strong>Total Records: </strong>
                <span v-if="this.transactionReports.total_records == null"
                  >0</span
                >
                <span v-else>
                  {{
                    this.transactionReports.total_records.toLocaleString()
                  }}</span
                >
              </div>
            </div>

            <div v-if="isLoading == true">
              <div class="centered-spinner">
                <a-spin />
              </div>
            </div>

            <div v-else>
              <div class="mt-2">
                <div v-if="!this.form.show_total">
                  <div class="d-flex justify-content-between mt-3">
                    <p>
                      Click on any column header to sort on that column. Click
                      again to reverse order.
                    </p>
                    <div class="d-inline-flex ms-2">
                      <div>
                        <label class="mt-1">Show </label>
                      </div>
                      <div class="ms-2">
                        <b-select
                          class="form-select form-select-sm ml-1"
                          v-model.number="perPage"
                          @change="getTransactionReports"
                        >
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </b-select>
                      </div>
                      <div class="ml-2 ms-2">
                        <label class="mt-1">entries</label>
                      </div>
                    </div>
                  </div>

                  <div :class="[loading ? 'table-active' : '']">
                    <div class="table-responsive">
                      <table
                        class="
                          table
                          mt-2
                          table-bordered
                          border-light
                          table-relative
                        "
                      >
                        <thead>
                          <tr>
                            <th scope="col">Client Name</th>
                            <th
                              scope="col"
                              @click="sortOnColumn('fullname')"
                              style="cursor: pointer;"
                            >
                              <span style="white-space: nowrap;"
                                >Name
                                <font-awesome-icon icon="sort-up" />
                              </span>
                            </th>
                            <th
                              scope="col"
                              @click="sortOnColumn('date')"
                              style="cursor: pointer;"
                            >
                              <span style="white-space: nowrap;"
                                >Date
                                <font-awesome-icon icon="sort-up" />
                              </span>
                            </th>
                            <th
                              scope="col"
                              @click="sortOnColumn('type')"
                              style="cursor: pointer;"
                            >
                              <span style="white-space: nowrap;"
                                >Type
                                <font-awesome-icon icon="sort-up" />
                              </span>
                            </th>
                            <th
                              scope="col"
                              @click="sortOnColumn('bywhom')"
                              style="cursor: pointer;"
                            >
                              <span style="white-space: nowrap;"
                                >By Whom User Name
                                <font-awesome-icon icon="sort-up" />
                              </span>
                            </th>
                            <th scope="col" class="text-right">Dollars</th>
                            <th
                              scope="col"
                              @click="sortOnColumn('points')"
                              style="cursor: pointer;"
                              class="text-right"
                            >
                              <span style="white-space: nowrap;"
                                >Points
                                <font-awesome-icon icon="sort-up" />
                              </span>
                            </th>
                            <th
                              scope="col"
                              @click="sortOnColumn('productid')"
                              style="cursor: pointer;"
                            >
                              <span style="white-space: nowrap;"
                                >Item
                                <font-awesome-icon icon="sort-up" />
                              </span>
                            </th>
                             <th
                              scope="col"
                              @click="sortOnColumn('productid')"
                              style="cursor: pointer;"
                            >
                              <span style="white-space: nowrap;"
                                >Quantity
                                <font-awesome-icon icon="sort-up" />
                              </span>
                            </th>
                            <th
                              scope="col"
                              @click="sortOnColumn('ordernumber')"
                              style="cursor: pointer;"
                            >
                              <span style="white-space: nowrap;"
                                >Order Number
                                <font-awesome-icon icon="sort-up" />
                              </span>
                            </th>
                            <th scope="col">Program</th>
                            <th scope="col">Comments</th>
                          </tr>
                        </thead>
                        <tbody v-if="loading == true">
                          <div class="centered">
                            <a-spin />
                          </div>
                        </tbody>
                        <tbody>
                          <tr
                            v-if="
                              this.transactionReports.transaction_records ===
                                null
                            "
                          >
                            <div class="white-space">No records found</div>
                          </tr>
                          <tr
                            v-for="transaction in this.transactionReports
                              .transaction_records"
                            :key="transaction.index"
                            v-else
                          >
                            <td class="white-space">
                              {{ transaction.client_name }}
                            </td>
                            <td
                              class="white-space"
                              v-if="transaction.last_name !== ''"
                              @click="setName(transaction)"
                            >
                              <router-link
                                :to="{
                                  name: 'AdminTransactionRecordDetail',
                                  params: {
                                    Id: transaction.user_id,
                                  },
                                }"
                              >
                                {{ transaction.first_name }} {{ "" }}
                                {{ transaction.last_name }}
                              </router-link>
                            </td>

                            <td
                              class="white-space"
                              @click="setName(transaction)"
                              v-else
                            >
                              <router-link
                                :to="{
                                  name: 'AdminTransactionRecordDetail',
                                  params: {
                                    Id: transaction.user_id,
                                  },
                                }"
                              >
                                {{ transaction.first_name }}
                              </router-link>
                            </td>

                            <td class="white-space">
                              {{
                                moment(transaction.date).format(
                                  "MM/DD/YYYY hh:mm a"
                                )
                              }}
                            </td>
                            <td>{{ transaction.type }}</td>
                            <td class="white-space">
                              {{ transaction.by_whom_user_name }}
                            </td>
                            <td class="white-space text-right">
                              {{
                                transaction.type === "order" ||
                                transaction.type === "points subtracted" ||
                                transaction.type === "order tax"
                                  ? "-"
                                  : ""
                              }}{{
                                Number(transaction.dollars).toLocaleString(
                                  undefined,
                                  {
                                    minimumFractionDigits: 2,
                                  }
                                )
                              }}
                            </td>
                            <td class="white-space text-right">
                              <span
                                v-if="
                                  transaction.type === 'order' ||
                                    transaction.type === 'points subtracted' ||
                                    transaction.type === 'order tax'
                                "
                                class="badge badge-danger pl-1 pr-1"
                              >
                                -{{
                                  Number(transaction.points).toLocaleString(
                                    undefined,
                                    {
                                      minimumFractionDigits: 2,
                                    }
                                  )
                                }}</span
                              >
                              <span
                                v-else
                                class="badge badge-success pl-1 pr-1"
                                >{{
                                  Number(transaction.points).toLocaleString(
                                    undefined,
                                    {
                                      minimumFractionDigits: 2,
                                    }
                                  )
                                }}</span
                              >
                            </td>
                            <td class="">
                              {{ transaction.product_name }}
                            </td>
                             <td class="white-space ">
                              {{ transaction.quantity }}
                            </td>
                            <td class="white-space ">
                              {{ transaction.order_number }}
                            </td>
                            <td class="white-space">
                              {{ transaction.program_name
                              }}{{ " (" + transaction.program_id + ")" }}
                            </td>
                            <td
                              class="white-space-wrap"
                              v-html="transaction.comments"
                            ></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div class="d-flex justify-content-between mt-2">
                      <div>
                        <span
                          v-if="transactionReports.transaction_records === null"
                          >Showing 0 to 0 of 0 entries</span
                        >
                        <span v-else
                          >Showing
                          {{
                            (currentPage - 1) * transactionReports.page_size + 1
                          }}
                          to
                          {{
                            (currentPage - 1) * transactionReports.page_size +
                              transactionReports.selected_record_count
                          }}
                          of
                          {{ transactionReports.total_records }} entries</span
                        >
                      </div>
                      <div v-if="this.transactionReports.transaction_records">
                        <pagination
                          :data="this.transactionReports.transaction_records"
                          :totalPages="
                            Math.ceil(
                              this.transactionReports.total_records / perPage
                            )
                          "
                          :total="this.transactionReports.total_records"
                          :perPage="perPage"
                          :currentPage="currentPage"
                          @pagechanged="onPageChange"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="this.transactionReports.sub_total_details != null">
                  <div
                    v-if="this.transactionReports.sub_total_details.length > 0"
                  >
                    <div
                      class="mt-3"
                      v-for="subTotal in this.transactionReports
                        .sub_total_details"
                      :key="subTotal.id"
                    >
                      <h6>Subtotal by {{ subTotal.display_name }}</h6>

                      <table
                        class="table table-sm table-bordered"
                        v-if="subTotal.type !== 'product'"
                      >
                        <thead>
                          <tr>
                            <th v-if="subTotal.type === 'client'">Client</th>
                            <th v-if="subTotal.type === 'bywhom'">
                              User (Username)
                            </th>
                            <th v-if="subTotal.type === 'code'">Code</th>
                            <th v-if="subTotal.type === 'program'">
                              Programs & Contests
                            </th>

                            <th>Added</th>
                            <th>Credits</th>
                            <th>Credit Taxes</th>
                            <th>Sales Taxes</th>
                            <th>Credit Sales Taxes</th>
                            <th>Subtracted</th>
                            <th>Orders</th>
                            <th>Order Taxes</th>
                            <th>Rebate</th>
                            <th>Total</th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr v-if="subTotal.records === null">
                            <div class="white-space">No records found</div>
                          </tr>
                          <tr
                            v-for="trans in subTotal.records"
                            :key="trans.index"
                            v-else
                          >
                            <td>{{ trans.entity_name }}</td>
                            <td>{{ trans.added.toLocaleString("en-US") }}</td>
                            <td>{{ trans.credits.toLocaleString("en-US") }}</td>
                            <td>
                              {{ trans.credit_taxes.toLocaleString("en-US") }}
                            </td>
                            <td>{{ trans.sales_taxes.toLocaleString("en-US") }}</td>
                            <td>0</td>
                            <td>
                              {{ trans.subtracted.toLocaleString("en-US") }}
                            </td>
                            <td>{{ trans.orders.toLocaleString("en-US") }}</td>
                            <td>
                              {{ trans.order_taxes.toLocaleString("en-US") }}
                            </td>
                            <td>{{ trans.rebate.toLocaleString("en-US") }}</td>
                            <td>{{ trans.total.toLocaleString("en-US") }}</td>
                          </tr>
                        </tbody>
                        <tfoot v-if="subTotal.total_info && subTotal.records">
                          <tr>
                            <td>{{ subTotal.total_info.entity_name }}</td>
                            <td>
                              {{
                                subTotal.total_info.added.toLocaleString(
                                  "en-US"
                                )
                              }}
                            </td>
                            <td>
                              {{
                                subTotal.total_info.credits.toLocaleString(
                                  "en-US"
                                )
                              }}
                            </td>
                            <td>
                              {{
                                subTotal.total_info.credit_taxes.toLocaleString(
                                  "en-US"
                                )
                              }}
                            </td>
                            <td>{{ subTotal.total_info.sales_taxes.toLocaleString("en-US") }}</td>
                            <td>0</td>
                            <td>
                              {{
                                subTotal.total_info.subtracted.toLocaleString(
                                  "en-US"
                                )
                              }}
                            </td>
                            <td>
                              {{
                                subTotal.total_info.orders.toLocaleString(
                                  "en-US"
                                )
                              }}
                            </td>
                            <td>
                              {{
                                subTotal.total_info.order_taxes.toLocaleString(
                                  "en-US"
                                )
                              }}
                            </td>
                            <td>
                              {{
                                subTotal.total_info.rebate.toLocaleString(
                                  "en-US"
                                )
                              }}
                            </td>
                            <td>
                              {{
                                subTotal.total_info.total.toLocaleString(
                                  "en-US"
                                )
                              }}
                            </td>
                          </tr>
                        </tfoot>
                      </table>

                      <table
                        class="table table-sm table-bordered"
                        v-if="subTotal.type === 'product'"
                      >
                        <thead>
                          <tr>
                            <th>Product Name</th>
                            <th>Product SKU</th>
                            <th>Count</th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr v-if="subTotal.product_records === null">
                            <div class="white-space">No records found</div>
                          </tr>
                          <tr
                            v-for="trans in subTotal.product_records"
                            :key="trans.index"
                          >
                            <td>{{ trans.product_name }}</td>
                            <td>{{ trans.sku }}</td>
                            <td>{{ trans.count }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <appFooter class="footer"></appFooter>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import AdminSidebar from "@/views/admin/AdminSidebar.vue";
import Pagination from "@/components/Pagination.vue";

import moment from "moment";

export default {
  name: "TransactionReportView",

  components: {
    appHeader: Header,
    appFooter: Footer,
    appAdminSidebar: AdminSidebar,
    pagination: Pagination,
  },

  data() {
    return {
      isLoading: false,
      loading: false,
      perPage: 10,
      currentPage: 1,
    };
  },
  computed: {
    transactionReports() {
      return this.$store.getters["transactionReport/getTransactionReport"];
    },
    form() {
      return this.$store.state.transactionReport.form;
    },
  },

  mounted() {
    this.isLoading = true;
    this.$store
      .dispatch("transactionReport/addTransactionReport", {
        form: this.form,
        params: {
          pg_num: 1,
          pg_size: 10,
        },
      })
      .then(() => {
        this.isLoading = false;
      });
  },

  methods: {
    setActiveMenuItem: function() {
      this.$store.dispatch("adminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "reportsTransactionReport",
        activeMenu: this.activeMenu ? this.activeMenu : "reports",
      });
    },
    onPageChange(page) {
      this.loading = true;
      this.currentPage = page;
      this.$store
        .dispatch("transactionReport/addTransactionReport", {
          form: this.form,
          params: {
            pg_num: this.currentPage,
            pg_size: this.perPage,
          },
        })
        .then(() => {
          this.loading = false;
        });
    },
    getTransactionReports() {
      console.log("filter");
      this.loading = true;
      this.currentPage = 1;
      this.$store
        .dispatch("transactionReport/addTransactionReport", {
          form: this.form,
          params: {
            pg_num: this.currentPage,
            pg_size: this.perPage,
          },
        })
        .then(() => {
          this.loading = false;
          console.log(this.transactionReports)
        });
    },
    format_date(value) {
      if (value) {
        return moment(String(value)).format("MM-DD-YYYY");
      }
    },
    setName(transaction) {
      let name = transaction.last_name
        ? transaction.first_name + " " + transaction.last_name
        : transaction.first_name;
      this.$store.state.transactionReport.name = name;
    },
    sortOnColumn(field) {
      this.form.sort_on = field;
      this.$store.dispatch("transactionReport/addTransactionReport", {
        form: this.form,
        params: {
          pg_num: this.currentPage,
          pg_size: this.perPage,
        },
      });
    },
  },
  created() {
    this.setActiveMenuItem();
  },
};
</script>

<style lang="scss" scoped>
.login-orders-report {
  //   margin: 70px 0 0 0;
  min-height: 100%;
  margin: -14px 0 0 0;
  .badge {
    font-size: 0.8rem;
    padding: 6px 0px;
    border-radius: $border-radius-sm;
  }
}

.white-space {
  white-space: nowrap !important;
}

.white-space-wrap {
  white-space: normal !important;
}

tr:nth-child(even) {
  background-color: #f2f2f2 !important;
}

.table-sm {
  font-size: 0.8rem;
}

.centered {
  position: absolute;
  top: 50%;
  left: 40%;
  transform: translate(-50%, -50%);
  transform: -webkit-translate(-50%, -50%);
  transform: -moz-translate(-50%, -50%);
  transform: -ms-translate(-50%, -50%);
  color: darkred;
  z-index: 5000;
  opacity: 1 !important;
}

.table-active {
  opacity: 0.4;
}

.centered-spinner {
  position: fixed;
  top: 62%;
  left: 62%;
  transform: translate(-50%, -50%);
  transform: -webkit-translate(-50%, -50%);
  transform: -moz-translate(-50%, -50%);
  transform: -ms-translate(-50%, -50%);
  color: darkred;
  z-index: 9999;
}

.table-relative {
  position: relative;
}

html,
body {
  height: 100%;
}
</style>
